import { IntegrationAttributes } from '@shared/model';

export class OrderUnit {
  orderUnitNonCombo: OrderUnitNonCombo | undefined;
  orderUnitCombo: OrderUnitCombo | undefined;
  displayName: string | undefined;
  price = 0;
  numberOfItems = 1;
  baseImageId: string | undefined;
  imageUrl: string | undefined;
  attributesString = '';
  attributes: string[] = [];
  size = '';
  posIds: string[] | undefined;
}

export interface CompletedOrderTotal {
  orderId: string;
  subTotal: number;
  tax: number;
  total: number;
}

export class PendingOrderUnit {
  id?: string;
  operationType?: string;
  name?: string;
  description?: string;
  items?: PendingOrderItem[];
  imageUrl?: string;
  integrationAttributes?: IntegrationAttributes;
}

export class PendingOrderItem {
  id?: string;
  operationType?: string;
  category?: string;
  name?: string;
  description?: string;
  primaryId?: string;
  integrationAttributes?: IntegrationAttributes;
  comboItemType?: string;
  modifiers?: Modifier[];
  basePrice?: number;
  details?: any;
}

export class OrderUnitCombo {
  main: OrderUnitNonCombo | undefined;
  beverage: OrderUnitNonCombo | undefined;
  side: OrderUnitNonCombo | undefined;
  size: string | undefined;
  combo: string | undefined;
  baseImageId: string | undefined;
  imageUrl: string | undefined;
  numberOfItems = 1;
  totalPrice = 0;

  displayName = '';
  price = 0;
  attributesString = '';
}

export class OrderUnitNonCombo {
  baseOrderItem: BaseOrderItem | undefined;
  quantity: string | undefined;
  size: string | undefined;
  flavor: string | undefined;
  sauce: string | undefined;
  baseImageId: string | undefined;
  imageUrl: string | undefined;
  numberOfItems = 1;
  totalPrice = 0;
  price = 0;
  displayName = '';
  modifiersWrapper: ModiferWrapper | undefined;
  attributesString = '';
}

export class BaseOrderItem {
  category: string | undefined;
  name: string | undefined;
}

export class ModiferWrapper {
  modifiers: Modifier[];

  constructor() {
    this.modifiers = [];
  }
}

export class Modifier {
  ingredient: string | undefined;
  hotBeverageExtra: string | undefined;
  modifierAmount: string | undefined;
  price: number | undefined;
  totalPrice: number | undefined;
  quantity = 0;
}

export class OrderSummary {
  cart: OrderUnit[] = [];
  cartPrice = 0;
  subtotal = 0;
  tax = 0;
  total = 0;
}
